import { Link } from "@inertiajs/react"

export function LandingFooter() {
  return (
    <footer className="border-t border-border">
      <div className="mx-auto flex max-w-6xl flex-col gap-4 px-6 py-8 text-sm text-muted-foreground sm:flex-row sm:items-center sm:justify-between">
        <div>
          &copy; {new Date().getFullYear()} Bitmapped Designs. All rights
          reserved.
        </div>
        <div className="flex gap-6">
          <Link href="/privacy" className="hover:text-foreground">
            Privacy
          </Link>
          <Link href="/terms" className="hover:text-foreground">
            Terms
          </Link>
          <a
            href="mailto:colleen@bitmappeddesigns.com"
            className="hover:text-foreground"
          >
            Contact
          </a>
        </div>
      </div>
    </footer>
  )
}
